export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="rounded-3xl overflow-hidden relative mb-10">
          <div className="aspect-[21/9] md:aspect-[21/7] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20minimalist%20background%20with%20soft%20terracotta%20and%20cream%20gradients%2C%20subtle%20grain%20texture%2C%20artistic%20modern%20design%2C%20no%20objects%2C%20elegant%20European%20aesthetic%2C%20gentle%20color%20transition%2C%20suitable%20for%20fashion%20website%20CTA%20banner&width=1600&height=534&seq=cta-bg-v3&orientation=landscape"
              alt="Kakobuy Spreadsheet CTA"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading leading-tight text-foreground-950 mb-2">
            Odkryj najlepszy{' '}
            <em className="text-secondary-500">Kakobuy Spreadsheet</em>
          </p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-8">
            dla Polski i kup teraz
          </p>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
          >
            Przejdź do kakobuy spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}